export const GetAllPharmacies = (value, setState) => {
	if (value === 'all') {
		setState(null);
	} else {
		setState(value);
	}
};
